export const TABLE_VIEW  = 'TABLE_VIEW'
export const USER_ADMIN_ROLE = 500
export const USER_STATUS_ACTIVE = 61
export const USER_ALERT_STATUS_OPENED = 70
export const USER_ALERT_STATUS_ESCALATED = 72
export const USER_ALERT_STATUS_EMAIL_SENT = 74
export const PATIENT_GOAL_STATUS_ACTIVE = 120
export const PATIENT_GOAL_STATUS_INACTIVE = 121
export const PATIENT_PATHWAY_STATUS_ACTIVE = 130
export const PATIENT_PATHWAY_STATUS_INACTIVE = 131